import { selectPlaceData, selectPlaceStatus } from './placeSlice'
import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { useSelector } from 'react-redux'
import { STATUS } from 'utils/constants'

const DetailsLocation = () => {
  const status = useSelector(selectPlaceStatus)
  const { street, estateNumber, localNumber, city, placeName } = useSelector(selectPlaceData)
  const succeed = status === STATUS.succeed

  const { t } = useTranslation('mapDetails')

  return (
    <div className='details__location'>
      <div className='location__main'>
        {succeed ? <>
          <div className='location__title --secFont'>{placeName}</div>
          <div className='location__subtitle'>{city}, {t('st')}{street} {estateNumber}{localNumber ? `/${localNumber}` : ''}</div>
        </> : <Skeleton
          count={1}
          containerClassName='skeleton__desc'
          style={{
            '--skeleton-base': '#353535',
            '--skeleton-highlight': '#393939'
          }} />}
      </div>
    </div>
  )
}

export default DetailsLocation